// Configuration for controlling page visibility based on environment
// Set to false to hide pages in production, true to show them

export const pageConfig = {
  // Production pages (always visible)
  home: true,
  about: true,
  howItWorks: true,
  stories: true,
  faq: true,
  waitlist: true,
  privacyPolicy: true,
  forPartners: true,
  forInsurers: true,
  forUtilities: true,
  bookDemo: true,
  aboutInspections: true,
  
  // Development/staging pages (can be toggled)
  // Set these to false to hide from production
  forRealEstateBrokers: true, // New page - now visible in production
} as const;

// Helper function to check if a page should be visible
export const isPageVisible = (pageKey: keyof typeof pageConfig): boolean => {
  try {
    // Defensive guard against undefined import.meta.env
    const isDevelopment = import.meta?.env?.DEV || false;
    
    // Defensive guard against window being undefined
    const hostname = typeof window !== 'undefined' ? window.location?.hostname : '';
    const isStaging = hostname.includes('deploy-preview') || hostname.includes('staging');
    
    // In development or staging, show all configured pages regardless of their value
    if (isDevelopment || isStaging) {
      return true;
    }
    
    // In production, only show if explicitly enabled
    return pageConfig[pageKey] || false;
  } catch (error) {
    console.error('Error in isPageVisible:', error);
    // Safe fallback: only show main pages if there's an error
    return ['home', 'about', 'howItWorks', 'waitlist'].includes(pageKey);
  }
};